import apiClient from "./client";

export async function getPlayerProfile(webUsername) {
  return apiClient.get(`/profiles/by-web-username/${encodeURIComponent(webUsername)}`);
}

export async function getPlayerProfilePreview(webUsername) {
  return apiClient.get(`/profiles/by-web-username/${encodeURIComponent(webUsername)}/preview`);
}

export async function getMyProfilePrivacy() {
  return apiClient.get("/profiles/me/profile-privacy");
}

/** All synced/displayable modules for the current player (visibility toggles ignored). */
export async function getMySyncedProfileModules() {
  return apiClient.get("/profiles/me/synced-modules");
}

export async function patchMyProfilePrivacy(moduleVisibility) {
  return apiClient.patch("/profiles/me/profile-privacy", { moduleVisibility });
}

export async function getMyNotificationPreferences() {
  return apiClient.get("/profiles/me/notification-preferences");
}

export async function patchMyNotificationPreferences(emailCategories) {
  return apiClient.patch("/profiles/me/notification-preferences", { emailCategories });
}

export async function getGlobalMentionSuggestions(query) {
  const qs = new URLSearchParams({ q: query });
  return apiClient.get(`/profiles/mention-suggestions?${qs.toString()}`);
}

export async function resolveMentionUsernames(usernames) {
  return apiClient.post("/profiles/resolve-mentions", { usernames });
}
